import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "164",
  height: "292",
  fill: "none",
  viewBox: "0 0 164 292"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#shipment_protection_footer_teal_svg__a)\"><rect width=\"105\" height=\"105\" x=\"4.53\" y=\"90.933\" fill=\"#337079\" rx=\"52.5\" transform=\"rotate(-60 4.53 90.933)\"></rect><path stroke=\"#fff\" stroke-opacity=\".2\" stroke-width=\"2\" d=\"M60.679 99.19c9.01-5.203 16.519-9.537 21.775-12.571l7.387-4.265c29.673 52.469 11.563 119.155-40.747 149.357s-119.12 12.542-149.722-39.391l7.388-4.266 21.774-12.572 66.072-38.147z\"></path></g><defs><clipPath id=\"shipment_protection_footer_teal_svg__a\"><path fill=\"#fff\" d=\"M0 0h164v292H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }